import { produce } from "immer";
import { SET_STEP, INCREMENT_STEP, DECREMENT_STEP, SET_SELECTED_SOURCES, SET_SELECTED_TABLES, SET_SELECTED_FOLDERS, SET_CSV_FILES } from "./onboarding.type";

const INITIAL_STATE = {
    currentStep: 0,
    totalSteps: 4,
    selectedAssets: {
        sources: [], // ['unity-catalogue', 'azure-data-lake', 'manual']
        tables: {}, // { databaseId: [tableId1, tableId2] }
        folders: [], // [folderId1, folderId2]
        csvFiles: [], // [{ name: string, size: number }]
        tableConfigs: {} // { tableId: { config: object } }
    }
};

const onboardingReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_STEP: {
            return produce(state, (draft) => {
                draft.currentStep = payload;
            });
        }
        case INCREMENT_STEP: {
            return produce(state, (draft) => {
                if (draft.currentStep < draft.totalSteps - 1) {
                    draft.currentStep += 1;
                }
            });
        }
        case DECREMENT_STEP: {
            return produce(state, (draft) => {
                if (draft.currentStep > 0) {
                    draft.currentStep -= 1;
                }
            });
        }
        case SET_SELECTED_SOURCES: {
            return produce(state, (draft) => {
                draft.selectedAssets.sources = payload;
            });
        }
        case SET_SELECTED_TABLES: {
            return produce(state, (draft) => {
                draft.selectedAssets.tables = payload;
            });
        }
        case SET_SELECTED_FOLDERS: {
            return produce(state, (draft) => {
                draft.selectedAssets.folders = payload;
            });
        }
        case SET_CSV_FILES: {
            return produce(state, (draft) => {
                draft.selectedAssets.csvFiles = payload;
            });
        }
        default:
            return state;
    }
};

export default onboardingReducer; 